import { IconClock, IconCalendarEvent } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { MemberSelectView } from '@/components/common/MemberSelect';
import { DateInputWithMask } from '../../../components/DateInputWithMask';
import { getStringError } from '../../../utils/formErrorHelpers';
import type { BasicInfoFieldsProps } from '../Step1BasicInfo.types';
import styles from './BasicInfoFields.module.css';

export function BasicInfoFields({
  form,
  isLoading = false,
  members,
  isMembersLoading,
}: BasicInfoFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.fieldsContainer}>
      <div className={styles.datesRow}>
        <DateInputWithMask
          className={styles.startDateField}
          label={t('taskForm.startDate')}
          leftSection={<IconCalendarEvent size={16} />}
          value={form.values.startDate || ''}
          onChange={(dateString) => form.setFieldValue('startDate', dateString)}
          disabled={isLoading}
          error={getStringError(form.errors.startDate)}
        />

        <DateInputWithMask
          className={styles.dueDateField}
          label={t('taskForm.dueDate')}
          leftSection={<IconClock size={16} />}
          value={form.values.dueDate || ''}
          onChange={(dateString) => form.setFieldValue('dueDate', dateString)}
          disabled={isLoading}
          error={getStringError(form.errors.dueDate)}
        />
      </div>

      <MemberSelectView
        className={styles.assigneeField}
        label={t('taskForm.assignee')}
        placeholder={t('taskForm.assigneePlaceholder')}
        value={form.values.assignedToId}
        onChange={(value) => form.setFieldValue('assignedToId', value ?? '')}
        disabled={isLoading}
        error={getStringError(form.errors.assignedToId)}
        members={members}
        isMembersLoading={isMembersLoading}
      />
    </div>
  );
}
